import { Typography } from '@mui/material';
import React from 'react';

interface IProps {
  name: string;
  variant?: 'body1' | 'body2';
  color?: 'text.primary' | 'text.secondary';
}

export const OptionNameLine: React.FC<IProps> = ({ name, variant = 'body1', color = 'text.primary' }) => (
  <Typography variant={variant} color={color}>
    {name}
  </Typography>
);
